<div class="row" [ngClass]="loading ? 'visually-hidden': ''">
    <div *ngIf="totalCount <= 0">
        <app-results-zero-view [queryString]="qs" [routeLink]="routeLink"></app-results-zero-view>
    </div>
    <div *ngIf="totalCount > 0">
        <div *ngIf="viewItems.length == 0">
        <div class="row">
            <div class="col-12">
                <app-results-search-info [queryString]="qs" [routeLink]="routeLink"></app-results-search-info>
                <app-results-zero-facet></app-results-zero-facet>
            </div>
        </div>
    </div>
    <div *ngIf="viewItems.length > 0">
        <div id="results-top"></div>
        <div class="overlay" *ngIf="showOverlay"></div>
        <div class="row">
            <!-- <div [ngClass]="facetsVisible ? 'col-3  p-2': ' '" class="notMobile">
                <app-nav-left></app-nav-left>
            </div> -->
            <div [ngClass]="facetsVisible ? 'col-12 ps-2' : ' ps-3'" class="notMobile">
                <app-results-search-info [queryString]="qs" [routeLink]="routeLink"></app-results-search-info>
                <div class="mt-4 mb-4"></div>
                <p-panel class="p-fluid mt-2 results">
                    <ng-template pTemplate="header">
                        <div class="container notMobile">
                            <div class="d-flex justify-content-between">
                                <div class="flex-item mt-2 mb-2">
                                    <span class="section-header notMobile">Search Results</span>
                                    <span class="forMobile">Results</span>
                                </div>
                                <div class="flex-item mt-2 mb-2">
                                    <span *ngIf="currentView === 'summary'">
                                        <button type="button" class="btn btn-secondary btn-sm me-2"
                                            (click)="toggleView(constants.results_view_table);">
                                            <i class="fas fa-table notMobile"></i> Table View</button>
                                    </span>
                                    <span *ngIf="currentView == 'table'">
                                        <!-- <button type="button" class="btn btn-secondary btn-sm me-2"
                                            (click)="toggleView(constants.results_view_summary);"><i
                                                class="fas fa-list notMobile"></i> Summary View</button> -->
                                        <button type="button" class="btn btn-secondary btn-sm me-2"
                                            (click)="showCreateReport();"><i class="fa fa-file-excel notMobile"></i> 
                                            Report</button>
                                        <button type="button" class="btn btn-secondary btn-sm me-2"
                                            (click)="showDownloadDocs();"><i class="fa fa-file-arrow-down notMobile"></i> Download
                                            </button>
                                        <p-popover #columnsop>
                                                <app-columns-select-panel [cols]="columnsSvc.cols"
                                                    (columnsChangedEvent)="updateCols($event);">
                                                </app-columns-select-panel>
                                        </p-popover>
                                            <button type="button" class="btn btn-secondary btn-sm me-2"
                                                (click)="columnsop.toggle($event);"><i class="fas fa-table-columns notMobile"></i>
                                                Columns</button>
                                        <p-popover #sortop>
                                            <app-sort-select-panel (executeSort)="sortItems($event);"
                                                (executeSortReset)="resetSort();"></app-sort-select-panel>
                                        </p-popover>
                                        <button type="button" class="btn btn-secondary btn-sm me-2"
                                            (click)="sortop.toggle($event);"><i class="fas fa-sort notMobile"></i>
                                            Sort</button>
                                    </span>

                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <p-scrollTop styleClass="scrolltop-location custom-scrolltop"
                        buttonAriaLabel="Scroll To Top"></p-scrollTop>
          <!-- Bread Crumbs-->
          <!-- <p-breadcrumb class="max-w-full" [model]="" [home]="" (onItemClick)="$event.item.command">placeholder</p-breadcrumb> -->

                    <div *ngIf="currentView==='table'">
                        <app-results-table-view [loading]="loading" [viewItems]="viewItems" [totalCount]="totalCount"
                            (docDetails)="showDocDetails($event)" (shareLink)="showShareDialog($event)"
                            (addNewCols)="updateCols($event)">
                        </app-results-table-view>
                    </div>
                </p-panel>
                <app-results-actions [total]="totalCount" [first]="first" [query]="qs" [currentView]="currentView"
                    [routeLink]="routeLink" (onPageChange)="paginate($event)" [pageSize]="pageSize"
                    (onToggleFacets)="toggleFacets($event)" (changeView)="toggleView($event)"></app-results-actions>
            </div>
            <!-- <div [ngClass]="facetsVisible ? 'col-12  p-2': ' '" class="forMobile">
                <app-results-facets [facets]="facets" (onApplyFacets)="applyFacets($event)"
                    [facetsVisible]="facetsVisible" (onToggleFacets)="toggleFacets($event)"></app-results-facets>
            </div> -->
            <div [ngClass]="facetsVisible ? 'col-12 ps-2' : ' ps-3'" class="forMobile">
                <app-results-search-info [queryString]="qs" [routeLink]="routeLink"></app-results-search-info>
                <app-results-actions [total]="totalCount" [first]="first" [query]="qs" [currentView]="currentView"
                    [routeLink]="routeLink" (onPageChange)="paginate($event)" [pageSize]="pageSize"
                    (onToggleFacets)="toggleFacets($event)" (changeView)="toggleView($event)"></app-results-actions>
                <p-panel class="p-fluid mt-2 results">
                    <ng-template pTemplate="header">
                        <div class="container forMobile">
                            <div>
                                <div class="mt-2 mb-2"  style="display: block;">
                                    <span>Results</span>
                                </div>
                                <div class="mt-2 mb-2"  style="display: block;" *ngIf="currentView == 'table'">
                                        <button type="button" class="btn btn-secondary btn-sm me-2 mt-2"
                                            (click)="showCreateReport();"><i class="fa fa-file-excel notMobile"></i> 
                                            Report</button>
                                        <button type="button" class="btn btn-secondary btn-sm me-2 mt-2"
                                            (click)="showDownloadDocs();"><i class="fa fa-file-arrow-down notMobile"></i> Download
                                            </button>
                                        <p-popover #columnsop>
                                            <app-columns-select-panel [cols]="columnsSvc.cols"
                                                (columnsChangedEvent)="updateCols($event);">
                                            </app-columns-select-panel>
                                        </p-popover>
                                        <button type="button" class="btn btn-secondary btn-sm me-2 mt-2"
                                            (click)="columnsop.toggle($event);"><i class="fas fa-table-columns notMobile"></i>
                                            Columns</button>
                                        <p-popover #sortop>
                                            <app-sort-select-panel (executeSort)="sortItems($event);"
                                                (executeSortReset)="resetSort();"></app-sort-select-panel>
                                        </p-popover>
                                        <button type="button" class="btn btn-secondary btn-sm me-2 mt-2"
                                            (click)="sortop.toggle($event);"><i class="fas fa-sort notMobile"></i>
                                            Sort</button>

                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <p-scrollTop styleClass="scrolltop-location custom-scrolltop"
                        buttonAriaLabel="Scroll To Top"></p-scrollTop>

                    <div *ngIf="currentView==='table'">
                        <app-results-table-view [loading]="loading" [viewItems]="viewItems" [totalCount]="totalCount"
                            (docDetails)="showDocDetails($event)" (shareLink)="showShareDialog($event)"
                            (addNewCols)="updateCols($event)">
                        </app-results-table-view>
                    </div>
                </p-panel>
                <app-results-actions [total]="totalCount" [first]="first" [query]="qs" [currentView]="currentView"
                    [routeLink]="routeLink" (onPageChange)="paginate($event)" [pageSize]="pageSize"
                    (onToggleFacets)="toggleFacets($event)" (changeView)="toggleView($event)"></app-results-actions>
            </div>
        </div>
    </div>    
    </div>
</div>
<app-reports-dialog [createReportVisible]="showReportDialog" (closeDialog)="hideReports();"
    (executeDownload)="downloadSelected($event);"></app-reports-dialog>
<app-download-dialog [downloadVisible]="showDownloadDialog" (closeDialog)="hideDownloadDocs();"></app-download-dialog>
<p-toast key="columnAdded" position="top-left"></p-toast>
<!-- Report Download Progress Bar and Cancel Toast -->
<p-dialog header="Downloading {{reportType}} Report" [(visible)]="isDownloading" [style]="{width:'30vw'}"
    (onHide)="executeCancelDownload();">
    <p-progressBar [value]="progress"></p-progressBar>
</p-dialog>
<p-toast key="csvcancel"></p-toast>
<p-toast key="downloadFiles" position="bottom-left"></p-toast>